<template>
  <div>
    <div class="records-panel-btn" @click="switchModal()">
      <v-icon>{{ showModal ? 'mdi-arrow-down-bold-hexagon-outline':'mdi-arrow-up-bold-hexagon-outline'}}</v-icon>
      {{ showModal ? 'закрыть':'открыть'}} панель записи
    </div>
    <div
        v-if="infoPad.info"
        class="info-pad"
        :style="'top:'+ infoPad.posY + 'px;left:' + infoPad.posX + 'px'"
    >
      статус: <span :style="infoPad.info.confirmed ? 'color:green;' : 'color:red;'">{{ infoPad.info.confirmed ? '' : 'не' }} подтверждена</span>
      <span v-if="infoPad.info.user_data">
        <br>
        клиент: {{ infoPad.info.user_data.surname}} {{ infoPad.info.user_data.name}}
        <br>
        телефон: {{ infoPad.info.user_data.phone}}
      </span>
      <br>
      Время: {{ infoPad.info.time }}
      <br>
      сервис:{{ infoPad.info.service_type }}
      <span v-if="infoPad.info.selected_car">
        <hr>
        Автомобиль: {{ carMarkModel(infoPad.info) }}
      </span>
      <span v-if="infoPad.info.selected_services">
        <hr>
        услуги:
        <template v-for="(service) in infoPad.info.selected_services">
          <span :key="service.id">
            <br>
          - {{ service.title }}
          </span>
        </template>
      </span>
    </div>
    <v-dialog
        v-model="showModal"
        fullscreen
        transition="scroll-y-reverse-transition"
    >
      <v-card>
        <v-btn
            text
            class="close-dialog-btn"
            @click="closeModal()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-title>
          Окно записи
          <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="date"
                  label="Дата"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  style="max-width: 180px"
                  class="ml-2 pt-2"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="date"
                locale="ru-ru"
                :first-day-of-week="1"
                @input="menu1 = false"
            ></v-date-picker>
          </v-menu>
        </v-card-title>
        <v-card
            class="ma-4 pa-4"
            elevation="1"
        >
          <v-card-title>
            {{ workshop.address }}
          </v-card-title>
          <v-card-text style="overflow-y: scroll">
            <table
                class="records-panel-table"
                @mouseleave="clearInfoPad"
            >
              <thead>
              <tr>
                <th>Время</th>
                <template v-for="(t, indt) in timePoints">
                  <th :key="'time-'+indt">
                    {{t}}
                  </th>
                </template>
              </tr>
              </thead>
              <tbody>
              <template v-for="(post, indp) in posts">
                <tr
                    style="height: 60px"
                    :key="'row-' + indp"
                >
                  <td class="pa-3 text-left">
                    <div>
                      {{ post.title }}
                    </div>
                    <div class="pt-3">
                      <v-progress-linear
                          :value="recordsProcent(post.id)"
                          color="amber"
                          height="15px"
                      ></v-progress-linear>
                      {{ recordsProcent(post.id) }}%
                    </div>
                  </td>
                  <template v-for="(t, indt) in timePoints">
                    <td class="fill-height inner-cells" :key="'time-'+indt" >
                      <div
                          v-if="postRecordsSorted[post.id]"
                          class="d-flex fill-height time-quoter"
                      >
                        <div
                            :style="cellInfoColor(post.id,t)"
                            @mouseover="showInfo($event, post, t)"
                            @click="getRecord(post, t)"
                        >
                          {{ postRecordsSorted[post.id][t] && postRecordsSorted[post.id][t].startTime === t ? carMarkModel(postRecordsSorted[post.id][t]) : '' }}
                        </div>
                        <div
                            :style="cellInfoColor(post.id,plusMinute(t, 15))"
                            @mouseover="showInfo($event, post, plusMinute(t, 15))"
                            @click="getRecord(post, plusMinute(t, 15))"
                        >
                          {{ postRecordsSorted[post.id][plusMinute(t, 15)] && postRecordsSorted[post.id][plusMinute(t, 15)].startTime === plusMinute(t, 15) ? carMarkModel(postRecordsSorted[post.id][plusMinute(t, 15)]) : '' }}
                        </div>
                         <div
                             :style="cellInfoColor(post.id,plusMinute(t, 30))"
                             @mouseover="showInfo($event, post, plusMinute(t, 30))"
                             @click="getRecord(post, plusMinute(t, 30))"
                         >
                           {{ postRecordsSorted[post.id][plusMinute(t, 30)] && postRecordsSorted[post.id][plusMinute(t, 30)].startTime === plusMinute(t, 30) ? carMarkModel(postRecordsSorted[post.id][plusMinute(t, 30)]) : '' }}
                         </div>
                        <div
                            :style="cellInfoColor(post.id,plusMinute(t, 45))"
                            @mouseover="showInfo($event, post, plusMinute(t, 45))"
                            @click="getRecord(post, plusMinute(t, 45))"
                        >
                          {{ postRecordsSorted[post.id][plusMinute(t, 45)] && postRecordsSorted[post.id][plusMinute(t, 45)].startTime === plusMinute(t, 45) ? carMarkModel(postRecordsSorted[post.id][plusMinute(t, 45)]) : '' }}
                        </div>
                      </div>
                      <div
                          v-else
                          class="d-flex fill-height time-quoter">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </td>
                  </template>
                </tr>
              </template>
              </tbody>
            </table>
            <div class="legend d-flex justify-center mt-8">
              <div
                  v-for="(postType, indx) in recordsType"
                  :key="indx"
                  class="ma-2"
              >
                  {{ postType.name }}
                  <div :style="'width: 120px; height: 20px; background-color:' + postType.color"></div>
              </div>
            </div>
<!--            <div class="legend d-flex justify-center mt-8">-->
<!--              <div-->
<!--                  v-for="(service, indx) in serviceTypes"-->
<!--                  :key="indx"-->
<!--                  class="ma-2"-->
<!--              >-->
<!--                  {{ service.name }}-->
<!--                  <div :style="'width: 170px; height: 20px; background-color:' + service.color"></div>-->
<!--              </div>-->
<!--            </div>-->
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="loading"
        persistent
        width="300"
        style="z-index: 21000"
    >
      <v-card
          color="primary"
          dark
      >
        <v-card-text>
          <br>
          <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

const timePointsFn = (start, end) => {
  const tArray = []
  for (let i = start; i <= end; i++) {
    const hours = i < 10 ? '0' + i : i
    tArray.push(hours+':00')
  }
  return tArray
}

export default {
  name: "RecordsPanel",
  data: () => ({
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu1: false,
    loading: false,
    infoPad:{
      posX:null,
      posY:null,
      info:null
    },
    timePoints: [],
    showModal: false,
    posts: [
      {
        "id": "0067ab1a-7f08-45b9-8208-21de94bd1c67",
        "workshop_id": "fb3185fc-30f9-46a0-9981-8ded77986073",
        "service_types": [
          "carwash"
        ],
        "title": "Пост №1"
      },
      {
        "id": "74f1f4b9-4a74-4fa1-bc13-061ff0721504",
        "workshop_id": "fb3185fc-30f9-46a0-9981-8ded77986073",
        "service_types": [
          "carwash"
        ],
        "title": "Пост №2"
      },
      {
        "id": "48461d91-a6d3-45db-9a15-8145206de6d8",
        "workshop_id": "fb3185fc-30f9-46a0-9981-8ded77986073",
        "service_types": [
          "carwash"
        ],
        "title": "Пост №3"
      }
    ],
    postRecords: [
      {
        "id": "2677273e-8b20-461f-9e5e-38d5be7cfa97",
        "workshop_id": "0e23676b-3131-45de-a885-44fcbe78c68f",
        "post_id": "48461d91-a6d3-45db-9a15-8145206de6d8",
        "service_type": "TireFitting",
        "start": "2024-12-19T07:15:00Z",
        "end": "2024-12-19T07:30:00Z",
        "confirmed": true,
        "is_reserve": false,
        "type": "booking",
        "reason": null
      },
      {
        "id": "ecf672d1-0514-48c2-a96e-a46fabf9cd69",
        "workshop_id": "0e23676b-3131-45de-a885-44fcbe78c68f",
        "post_id": "74f1f4b9-4a74-4fa1-bc13-061ff0721504",
        "service_type": "TireFitting",
        "start": "2024-12-19T07:30:00Z",
        "end": "2024-12-19T08:00:00Z",
        "confirmed": false,
        "is_reserve": true,
        "type": "reserve",
        "reason": null
      },
      {
        "id": "e8743089-a6fe-49d6-9226-2745d65ed4d3",
        "workshop_id": "0e23676b-3131-45de-a885-44fcbe78c68f",
        "post_id": "74f1f4b9-4a74-4fa1-bc13-061ff0721504",
        "service_type": "TireFitting",
        "start": "2024-12-19T10:00:00Z",
        "end": "2024-12-19T17:15:00Z",
        "confirmed": false,
        "is_reserve": true,
        "type": "reserve",
        "reason": null
      },
      {
        "id": "f951b84a-aa52-4f8a-8a87-f423cb68b627",
        "workshop_id": "0e23676b-3131-45de-a885-44fcbe78c68f",
        "post_id": "0067ab1a-7f08-45b9-8208-21de94bd1c67",
        "service_type": "TireFitting",
        "start": "2024-12-18T08:00:00Z",
        "end": "2024-12-18T21:00:00Z",
        "confirmed": false,
        "is_reserve": true,
        "type": "reserve",
        "reason": null
      },
      {
        "id": "f951b84a-aa52-4f8a-8a87-f423cb68b627",
        "workshop_id": "0e23676b-3131-45de-a885-44fcbe78c68f",
        "post_id": "48461d91-a6d3-45db-9a15-8145206de6d8",
        "service_type": "TireFitting",
        "start": "2024-12-19T07:00:00Z",
        "end": "2024-12-19T07:15:00Z",
        "confirmed": true,
        "is_reserve": false,
        "type": "booking",
        "reason": null
      },
      {
        "id": "d457dcab-6501-438c-a050-1b5ec2d1cf44",
        "workshop_id": "0e23676b-3131-45de-a885-44fcbe78c68f",
        "post_id": "48461d91-a6d3-45db-9a15-8145206de6d8",
        "service_type": "TireFitting",
        "start": "2024-12-19T09:15:00Z",
        "end": "2024-12-19T09:30:00Z",
        "confirmed": false,
        "is_reserve": false,
        "type": "booking",
        "reason": null
      },
      {
        "id": "5ae906b5-4a6b-4c4b-9642-2eeb85786c5c",
        "workshop_id": "0e23676b-3131-45de-a885-44fcbe78c68f",
        "post_id": "48461d91-a6d3-45db-9a15-8145206de6d8",
        "service_type": "TireFitting",
        "start": "2024-12-19T10:45:00Z",
        "end": "2024-12-19T11:30:00Z",
        "confirmed": true,
        "is_reserve": false,
        "type": "booking",
        "reason": null
      }
    ],
    serviceTypes: [
        { "name": "шиномонтаж", "type": "booking", "service_type": "TireFitting", "color": "#0D3B66" },
        { "name": "заправка кондиционера", "type": "booking", "service_type": "a/c refill", "color": "#FAF0CA" },
        { "name": "автосервис", "type": "booking", "service_type": "service", "color": "#F4D35E" },
        { "name": "автомойка", "type": "booking", "service_type": "carwash", "color": "#EE964B" },
        { "name": "техосмотр", "type": "booking", "service_type": "inspection", "color": "#a96060" },
        { "name": "развал-схождение", "type": "booking", "service_type": "wheels alignment", "color": "#B1EDE8" },
    ],
    recordsType: [
        { "name": "запись", "type": "booking", "color": "#DBEAFEFF" },
        { "name": "резерв", "type": "reserve", "color": "#FEF9C3FF" },
    ]
  }),
  computed: {
    ...mapGetters('shift', [
      "shiftData"
    ]),
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    dayRecords () {
      return this.timePoints.length * 4
    },
    workshop () {
      return this.$store.state.login.workshop
    },
    postRecordsSorted () {
      if(this.postRecords && this.postRecords.length > 0) {
        const sorted = {}
        const addZero = (time) => {
          if (time < 10) {
            return '0' + time
          } else {
            return time
          }
        }
        this.postRecords.forEach((postRecord) => {
          if (!sorted[postRecord.post_id]) {
            sorted[postRecord.post_id] = {}
          }
          const diff = new Date(postRecord.end) - new Date(postRecord.start)
          if (diff > 900000) {
            let startHour = new Date(postRecord.start).getHours()
            let startMin = new Date(postRecord.start).getMinutes()
            const endHour = new Date(postRecord.end).getHours()
            const endMin = new Date(postRecord.end).getMinutes()
            postRecord.time = addZero(startHour)+':'+addZero(startMin) + ' - ' + addZero(endHour)+':'+addZero(endMin)
            postRecord.startTime = addZero(startHour)+':'+addZero(startMin)
            postRecord.finishTime = addZero(endHour)+':'+addZero(endMin)
            sorted[postRecord.post_id][addZero(startHour)+':'+addZero(startMin)] = postRecord
            for (let i=1; i<(diff/900000); i++) {
              if (startMin >= 45 && i > 0) {
                startMin = 0
                startHour++
              } else {
                startMin = startMin + 15
              }
              sorted[postRecord.post_id][addZero(startHour)+':'+addZero(startMin)] = postRecord
            }
          } else {
            const startHour = new Date(postRecord.start).getHours()
            const startMin = new Date(postRecord.start).getMinutes()
            sorted[postRecord.post_id][addZero(startHour)+':'+addZero(startMin)] = postRecord
          }

        })
        return sorted
      } else{
        return []
      }
    },
  },
  mounted() {
    this.timePoints = timePointsFn(0, 23)
    // this.$store.dispatch('login/getWorkshopPosts').then(response => {
    //   this.posts = response
    //   this.$store.dispatch('login/getWorkshopBookings').then(response => {
    //     this.postRecords = response
    //   })
    // })
  },
  methods: {
    getRecord(post, t) {
      this.loading = true
      console.log('---',post.id)
      console.log('---',t)
      console.log('---',this.postRecordsSorted[post.id])
      console.log('---',this.postRecordsSorted[post.id][t])
      const payload = {
        "booking_id": this.postRecordsSorted[post.id][t].id,
        "shift": { "id": this.shiftData.id},
        "selected_car": this.postRecordsSorted[post.id][t].selected_car,
        "selected_services": this.postRecordsSorted[post.id][t].selected_services,
        "user_data": this.postRecordsSorted[post.id][t].user_data,
      }
      if (this.postRecordsSorted[post.id][t].selected_car) {
        payload.userCars = this.postRecordsSorted[post.id][t].selected_car
      }
      this.$store.dispatch('importOrder', payload).then(response => {
        this.$router.push(`/order/${response.data.order_id}`)
        this.showModal = false
        this.loading = false
      }).catch((e)=>{
        console.log('Error:', e)
        this.loading = false
      })
    },
    clearInfoPad() {
      this.infoPad.posX = null
      this.infoPad.posY = null
      this.infoPad.info = null
    },
    carMarkModel (booking) {
      const mark = booking?.selected_car?.mark?.name || booking?.selected_car?.mark || ''
      const model = booking?.selected_car?.name || booking?.selected_car?.model || ''
      return mark + ' ' + model
    },
    showInfo(event, info, t) {
      if(this.postRecordsSorted[info.id] && this.postRecordsSorted[info.id][t]){
        console.log(event)
        if((event.view.innerWidth - event.pageX) > 320) {
          this.infoPad.posX = event.pageX + 10
        } else {
          this.infoPad.posX = event.pageX - 280
        }
        this.infoPad.posY = event.pageY + 10
        this.infoPad.info = this.postRecordsSorted[info.id][t]
      } else {
        this.infoPad.posX = null
        this.infoPad.posY = null
        this.infoPad.info = null
      }
    },
    // cellInfo(postId, time) {
    //   if (this.postRecordsSorted[postId] && this.postRecordsSorted[postId][time]) {
    //     return this.postRecordsSorted[postId][time]
    //   } else {
    //     return null
    //   }
    // },
    recordsProcent (post) {
      if (this.postRecordsSorted[post]) {
        const posts = Object.keys(this.postRecordsSorted[post]).length
        return Math.round(this.dayRecords/100 * posts)
      } else {
        return 0
      }
    },
    cellInfoColor(postId, time) {
      if (this.postRecordsSorted[postId] && this.postRecordsSorted[postId][time]) {
        const recordTypeColor = this.recordsType.find(type=>type.type.toLowerCase() === this.postRecordsSorted[postId][time].type.toLowerCase())
        // const recordServiceColor = this.serviceTypes.find(type=>type.service_type.toLowerCase() === this.postRecordsSorted[postId][time].service_type.toLowerCase())

        if (recordTypeColor) {
          // console.log('service_type',recordTypeColor.color)
          let addFade = ''

          if (!this.postRecordsSorted[postId][time].confirmed) {
            addFade = 'opacity:0.3;'
          } else {
            addFade = 'cursor:pointer;'
          }
          if (this.postRecordsSorted[postId][time].startTime === time) {
            addFade += 'border-right: 1px solid #bc5090 !important;'
          }
          if (this.postRecordsSorted[postId][time].finishTime)
          {
            let date1 = new Date(`2000-01-01T${time}Z`);
            let date2 = new Date(`2000-01-01T${this.postRecordsSorted[postId][time].finishTime}Z`);
            if(date2-date1 <= 900000) {
              addFade += 'border-left:1px solid #bc5090; '
            }
          }
          return addFade + ';background-color:' + recordTypeColor.color+'; border-top:1.5px solid #bc5090; border-bottom:1.5px solid #bc5090;'
// return addFade + 'background: linear-gradient(to bottom, ' + recordTypeColor.color + ' 0%,' +
//               recordTypeColor.color + ' 30%,'+ recordServiceColor.color + ' 31%,' + recordServiceColor.color + ' 100%);'
        } else {
          return null //'background-color:white'
        }
      } else {
        return null
      }
    },
    plusMinute(time, minute) {
      if(time && minute) {
        const hour = time.split(':')[0]
        return hour + ":" + minute
      } else {
        return null
      }
    },
    switchModal () {
      this.showModal = !this.showModal
    },
    closeModal () {
      this.showModal = false
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
  },
  watch: {
    date (val) {
      this.loading = true
      this.$store.dispatch('login/getWorkshopBookings', val).then(response => {
        this.postRecords = response
        this.loading = false
      }).catch((e) => {
        console.log('Error',e)
        this.loading = false
      })
    },
    showModal(newVal) {
      if (newVal) {
        this.loading = true
        this.$store.dispatch('login/getWorkshopPosts').then(response => {
          this.posts = response
          this.$store.dispatch('login/getWorkshopBookings',this.date).then(response => {
            this.postRecords = response
            this.loading = false
          }).catch((e) => {
            console.log('Error',e)
            this.loading = false
          })
        }).catch((e)=>{
          console.log('Error',e)
          this.loading = false
        })
      }
    }
  }
};
</script>

<style>
.info-pad {
  box-shadow: 2px 2px 1px rgba(0, 0, 0, 0.3);
  position: fixed;
  background-color: #ffffff;
  border: 1px solid #f67423;
  border-radius: 0 6px;
  min-height: 100px;
  width: 270px;
  padding: 10px;
  z-index: 25000;
}
.inner-cells {
  background-color: #ffffff;
}
.records-panel-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ccc;
  overflow: auto;
}
.records-panel-table th {
  height: 8vh;
  text-align: center;
  border: 1px solid #ccc;
}
.records-panel-table td {
  text-align: center;
  height: inherit;
  padding: 0px;
  border: 1px solid #ccc;
}
.records-panel-table tr {
  height: 1px;
}

.time-quoter {
  height: 100%;
  width: 100%;
}
.time-quoter div{
  font-size: xx-small;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  line-height: 15px;
  min-width: 15px;
  width: 100%;
  height: 120px;
  border: 0.5px solid #dfdfdf;
}
.close-dialog-btn {
  position: absolute;
  right: 20px;
  top: 20px;
}
.records-panel-btn {
  border-radius: 15px 15px 0px 0px;
  border: 1px solid #1943f1;
  position: fixed;
  bottom: 0;
  right: 100px;
  height: 35px;
  background-color: #00e676;
  z-index: 20000;
  padding: 5px 10px;
  cursor: pointer;
}
.records-panel-btn:hover {
  padding: 15px 12px 40px 12px;
}
</style>